import { render, staticRenderFns } from "./app-main.vue?vue&type=template&id=6a675caa&scoped=true&lang=pug&"
import script from "./app-main.vue?vue&type=script&lang=js&"
export * from "./app-main.vue?vue&type=script&lang=js&"
import style0 from "./app-main.vue?vue&type=style&index=0&id=6a675caa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a675caa",
  null
  
)

export default component.exports